import "./Sidebar.css";
import { NavLink, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { getBranchUsersWithoutTime } from "../../api/workingHoursApi";
import { logoutRequest } from "../../api/auth.api";

export default function Sidebar({ isOpen }) {
    const [noTimeUsersCount, setNoTimeUsersCount] = useState(0);
    const [hasUnassignedUsers, setHasUnassignedUsers] = useState(false);
    const navigate = useNavigate();

    const branch = JSON.parse(localStorage.getItem("branch"));

    useEffect(() => {
        loadUsers();
        checkUnassignedUsers();
    }, []);

    const loadUsers = async () => {
        try {
            const data = await getBranchUsersWithoutTime(branch.id);
            setNoTimeUsersCount(data.length);
        } catch (err) {
            console.error(err);
        }
    };

    const checkUnassignedUsers = () => {
        const users =
            JSON.parse(localStorage.getItem("branch_users")) || [];

        const hasUnassigned = users.some(
            (u) => u.role_id === null
        );

        setHasUnassignedUsers(hasUnassigned);
    };

    // 🔥 LOGOUT FUNCTION
    const handleLogout = async () => {
        try {
            await logoutRequest();

            localStorage.removeItem("branch");
            localStorage.removeItem("branch_users");

            navigate("/");
        } catch (err) {
            console.error("Logout error:", err);
        }
    };

    return (
        <aside className={`sidebar ${isOpen ? "open" : "closed"}`}>

            <h2 className="logo">
                {isOpen ? "Attendance Pro" : "AP"}
            </h2>

            <nav className="nav">

                <NavLink to="/dashboard">
                    Dashboard
                </NavLink>

                {noTimeUsersCount > 0 && (
                    <NavLink to="/working_hours">
                        <div className="nav-item">
                            <span>Working Hours</span>
                            <span className="badge">
                                {noTimeUsersCount}
                            </span>
                        </div>
                    </NavLink>
                )}

                {hasUnassignedUsers && (
                    <NavLink to="/brench_users">
                        Assign Roles
                    </NavLink>
                )}

                <NavLink to="/staff">
                    Staff Attendance
                </NavLink>

                <NavLink to="/students">
                    Student Attendance
                </NavLink>

            </nav>

            {/* 🔥 LOGOUT BUTTON PASTDA */}
            <div className="sidebar-footer">
                <button
                    className="logout-btn"
                    onClick={handleLogout}
                >
                    Logout
                </button>
            </div>

        </aside>
    );
}
